import * as THREE from 'three'
import $ from 'jquery'

var PositionalMedia = (function() {
    var SIZE = 100
    var MAX_HEIGHT = 200
    var MIN_LENGTH = 0.5
    var MAX_LENGTH = 30
    var CANVAS_WIDTH_DEFAULT = 2048
    var CANVAS_HEIGHT_DEFAULT = 1024

    var COLORS = {
        AUTOPLAY: '#1262CF',
        AUTOPLAY_TITLE_BACKGROUND: '#397AD3',
        DEFAULT: '#00cf92',
        DEFAULT_TITLE_BACKGROUND: '#50E3C2',
        DEFAULT_TITLE: 'white',
        WHITE: 'white',
        BACKGROUND: '#1D2832',
    }

    var po_last_intersection

    function positionalMediaMouseMove(intersection) {
        if (PositionalMedia.moving) {
            var po = PositionalMedia.moving.po,
                point = PositionalMedia.moving.point,
                from = po.mesh.position,
                plane = new THREE.Plane(from.clone().normalize(), -from.length())
            switch (PositionalMedia.moving.type) {
                case 'pin':
                    var intersects = intersection.point.setLength(SIZE / 10)
                    point.x = intersects.x
                    point.y = intersects.y
                    point.z = intersects.z
                    po.setPosition()
                    po.call('update', [po.arg])
                    PositionalMedia.current_panorama.setNeedsRefresh()
                    break
                case 'move':
                    var line_a = new THREE.Line3(new THREE.Vector3(0, 0, 0), intersection.point),
                        line_b = new THREE.Line3(new THREE.Vector3(0, 0, 0), po_last_intersection.point),
                        target_a = new THREE.Vector3(0, 0, 0),
                        target_b = new THREE.Vector3(0, 0, 0),
                        projection_a = plane.intersectLine(line_a, target_a),
                        projection_b = plane.intersectLine(line_b, target_b),
                        length = po.mesh.position.length()
                    if (projection_a && projection_b) {
                        var pos = po.mesh.position
                            .add(projection_a)
                            .sub(projection_b)
                            .setLength(length)
                        po.setPosition(pos)
                        var point = po.arg.points[0]
                        point.x = pos.x
                        point.y = pos.y
                        point.z = pos.z
                        po.call('update', [po.arg])
                        PositionalMedia.current_panorama.setNeedsRefresh()
                    }
                    break
                case 'resize':
                    var last = PositionalMedia.moving.last
                    if (last) {
                        var dx = PositionalMedia.current_panorama.camera.mouse.x - last.x,
                            dy = last.y - PositionalMedia.current_panorama.camera.mouse.y,
                            length = from.length() - (dx + dy) * 5
                        length = Math.min(Math.max(length, MIN_LENGTH), MAX_LENGTH)
                        from.setLength(length)
                        po.setPosition(from)
                        var point = po.arg.points[0]
                        point.x = from.x
                        point.y = from.y
                        point.z = from.z
                        po.call('update', [po.arg])
                        PositionalMedia.current_panorama.setNeedsRefresh()
                    }
                    break
            }
            PositionalMedia.moving.last = {
                x: PositionalMedia.current_panorama.camera.mouse.x,
                y: PositionalMedia.current_panorama.camera.mouse.y,
            }
        }
        po_last_intersection = intersection
    }

    function positionalMediaMouseUp() {
        PositionalMedia.focused && PositionalMedia.focused.setBorderVisible(true)
        PositionalMedia.moving = null
    }

    function positionalMediaMouseClick() {
        PositionalMedia.focused && PositionalMedia.focused.setFocused(false)
    }

    /**
     * Pano bind events
     */
    function panoramaBindMouseEvents(panorama, permission) {
        if (!panorama.hasPositionalMediaEvents) {
            PositionalMedia.current_panorama = panorama
            panorama.hasPositionalMediaEvents = true
            panorama.scene.addEvent('mouseup', positionalMediaMouseUp)

            if (!permission) {
                panorama.scene.addEvent('mouseup', positionalMediaMouseUp)
                panorama.scene.removeEvent('click', positionalMediaMouseClick)
            } else {
                panorama.scene.addEvent('mousemove', positionalMediaMouseMove)
                panorama.scene.addEvent('click', positionalMediaMouseClick)
            }
        }
    }

    /**
     * Pano Unbind events
     */
    function panoramaUnBindMouseEvents(panorama) {
        if (!panorama.hasPositionalMediaEvents) {
            panorama.scene.removeEvent('mousemove', positionalMediaMouseMove)
            panorama.scene.removeEvent('mouseup', positionalMediaMouseUp)
            panorama.scene.removeEvent('click', positionalMediaMouseClick)
            panorama.hasPositionalMediaEvents = false
            PositionalMedia.current_panorama = null
        }
    }

    var play_button = new Image()
    play_button.src = '/Assets/svg/icons/icon_pm_play.svg'
    var pause_button = new Image()
    pause_button.src = '/Assets/svg/icons/icon_pm_pause.svg'
    //CONSTANTS
    var convert_units = 100,
        button_size = 64 * 1.2

    function onload(image, callback) {
        if (image.complete) {
            callback.call(this)
        } else {
            if (!image.event) {
                image.event = new EventHandler(image)
                image.onload = function() {
                    image.event.call('load')
                }
            }
            image.event.add('load', callback)
        }
    }

    //todo abstract to api
    function resolveShowUI(po) {
        //TEMP hide UI for Dimension Data
        var showUI = 135685 != po.loc_id && 138310 != po.loc_id && 136683 != po.loc_id && 140314 != po.loc_id
        //Hide for Specific Medias
        showUI = showUI && (4333 != po.id && 4334 != po.id && 4335 != po.id)
        showUI = showUI && (4341 != po.id && 4342 != po.id && 4343 != po.id)
        return showUI
    }

    /**
     * Initialize Positional Media Object
     * @param Object positional media config
     * 		{
     * 			id: int, 			//unique id for pm
     * 			loc_id: int,  		//loc_id id of parent
     * 	  		viewMode: bool,  	//preview mode (Aria creator), render preview UI
     * 			status: bool,  		//processing status of pm
     * 			fade:bool,  		//blur edges to fade into background
     * 			showUI: bool,  		//show play / pause UI, some clients override
     * 			media:
     * 				{
     * 					photoURL: string [image|Still], //Photo URL or Video Still
     * 					videoURL: (optional) string [videoUrl] //Video to play if clicked
     * 				},
     * 			points: [x,y,z], 	//array of points to render media
     * 			sequenceId: int, 	//play order > 1 triggers autoplay based on order.
     * 			title: string, 		//title of PM (used for rendering preview (creator))
     *
     * 			//callbacks:
     * 			onPositionalMediaPlay: function, 	//called on pm play
     * 			onPositionalMediaPause: function, 	//called on pm pause
     * 			onFailedToPlay: function, 			//called on play failed (due to blocking?)
     * 			onRequestAppInstall: function,		//callback to launch app.
     * 		}
     * @param Panorama panorama to render pm to...
     */
    function PositionalMedia(po, panorama) {
        var scope = this
        //legacy support
        if (typeof po.media == 'undefined') {
            //Legacy Support for Aria Creator. TODO Update all references.
            if (po.mediumurl) {
                po.media = { photoURL: po.mediumurl }
            } else if (po.smallurl) {
                po.media = { photoURL: po.smallurl }
            } else {
                console.log('Invalid PositionalMedia Configration')
                return false
            }
        }

        //translade fade to numbe
        po.fade = Number(po.fade)

        po.showUI = resolveShowUI(po)

        THREE.Object3D.call(this)

        this.play = this.play.bind(this, false)
        this.pause = this.pause.bind(this)
        this.destroy = this.destroy.bind(this)
        this.isPlaying = this.isPlaying.bind(this)

        this.panorama = panorama
        PositionalMedia.current_panorama = panorama
        this.scene = panorama.scene
        this.points = [] //The handles in builder
        this.cylinders = [] //The edges for 4 point media
        this.singlePointEdges = [] //The edges for 1 point media

        this.arg = po
        //Refactor will make this more consistent
        this.mediaType = po.mediaType || po.type

        this.theta = 0
        this.dots = 1
        var self = this

        panorama.onDestroy(this.destroy)

        function drawVideo() {
            var texture = this.material.map,
                canvas = texture.image,
                mediaObject = canvas.mediaObject

            if (mediaObject && mediaObject.isVideo && !mediaObject.paused) {
                self.drawImage(mediaObject)
            }

            if (self.hasDrawnMedia && !self.arg.customUI) {
                var newPosition = self.getPosition()

                if (newPosition) {
                    self.moveTitle()
                    self.moveButton(newPosition)
                }
            }
        }

        var geometry = (this.geometry = this.getGeometry())

        var mesh = (this.mesh = videoTexture(geometry, po.media, function(mediaObject, width, height) {
            var last = new Date()
            self.bindVideoEvents(mediaObject)
            /**
             * Wait for ready state to render first frame.
             */

            var processingRenderer = function() {
                var isVideoReady = mediaObject.isVideo && mediaObject.readyState == 4
                if (self.isLive() && (isVideoReady || mediaObject.isPhoto)) {
                    if (po.points.length === 1) {
                        var geometry = self.getGeometry()
                        var scale = MAX_HEIGHT / Math.max(width, height)
                        geometry.scale(width * scale, height * scale, 1)
                        self.mesh.geometry = geometry
                        var point = po.points[0]
                        self.setPosition(new THREE.Vector3(point.x, point.y, point.z))
                    }
                    if (self.wasProcessing) self.renderPhoto()
                    self.drawImage(mediaObject)
                    self.mesh.material.map.needsUpdate = true
                    PositionalMedia.current_panorama && PositionalMedia.current_panorama.setNeedsRefresh()
                } else if (!self.isLive()) {
                    /* builder: update progress indicator... */
                    var now = new Date(),
                        delta = (now - last) / 1000
                    last = now
                    self.theta += 2 * Math.PI * delta
                    self.dots += delta
                    self.dots = Math.max(self.dots % 4, 1)
                    self.wasProcessing = true
                    self.drawImage(mediaObject)
                    PositionalMedia.current_panorama && PositionalMedia.current_panorama.setNeedsRefresh()
                    if (po.points.length === 1) {
                        var point = po.points[0]
                        self.setPosition(new THREE.Vector3(point.x, point.y, point.z))
                    }
                    requestAnimationFrame(processingRenderer)
                }
            }
            var interval = requestAnimationFrame(processingRenderer)

            //Allow autoplay
            if (po.autoplay && scope.viewMode) {
                scope.play(true)
            }
        }))

        this.drawVideo = drawVideo.bind(mesh)

        if (po.points.length === 1) {
            var spinner_canvas = mesh.material.map.image
            spinner_canvas.width = 410
            spinner_canvas.height = 230
            geometry.scale(spinner_canvas.width, spinner_canvas.height, 1)
        }
        mesh.renderOrder = 1
        this.scene.add(mesh)
        this.clearMoving()

        mesh.addEvent('mousedown', function() {
            if (!self.viewMode && self.arg.points.length === 1 && self.isFocused()) {
                self.setMoving('move')
            }
        })

        // Adds click listener to positional media mesh for custom ui's ebcause play/pause buttons are unavailable
        if (this.arg.custom_ui) {
            mesh.addEvent('click', () => {
                if (this.isPlaying()) {
                    this.pause()
                } else {
                    this.play()
                }
            })
        }

        if (po.disableTouch !== true) mesh.addEvent('touch', this.play)

        // if (this.deviceIsMobile()) {
        // 	panorama.onDrag(function(){
        // 		if (scope.isPlaying()) {
        // 			scope.pause();
        // 		}
        // 	});
        // }

        mesh.lookAt(new THREE.Vector3(0, 0, 0))

        //RESIZE OR DRAGGABLE
        this._updateHandles()
        //TITLE
        this._updateTitle()

        this.setViewMode(po.viewMode)
        this.setFocused(false)
        var point = po.points[0]
        self.setPosition(new THREE.Vector3(point.x, point.y, point.z))
    }

    /**
     * Reset mouse events, so we are the last event reciever
     */
    PositionalMedia.resetMouseEvents = function(panorama, permission, dontBind) {
        panoramaUnBindMouseEvents(panorama)
        if (!dontBind) {
            panoramaBindMouseEvents(panorama, permission)
        }
    }

    PositionalMedia.prototype = Object.create(THREE.Object3D.prototype)

    PositionalMedia.prototype.setMoving = function(type, point) {
        var panorama = PositionalMedia.current_panorama
        if (panorama) {
            panorama.camera.setMouseMoving(false)
            panorama.setConstantRefresh(true)
        }
        PositionalMedia.moving = {
            po: this,
            type: type,
            point: point,
        }
    }

    PositionalMedia.prototype.clearMoving = function() {
        PositionalMedia.moving = null
    }

    PositionalMedia.prototype.bindVideoEvents = function(mediaObject) {
        if (!mediaObject.isVideo) return

        var scope = this
        /**
         * Media Object Video Events
         */
        mediaObject.onplay = function(e) {
            scope.scene.addEvent('draw', scope.drawVideo)
            var keepAudio = PositionalMedia.lastPlay && PositionalMedia.lastPlay != scope
            scope.panorama && scope.panorama.setConstantRefresh(true)
            scope.arg.onPositionalMediaPlay &&
                scope.arg.onPositionalMediaPlay(e, { keepAudio: keepAudio, id: scope.arg.id })
        }
        mediaObject.onpause = function(e) {
            scope.scene.removeEvent('draw', scope.drawVideo)
            var keepAudio = PositionalMedia.lastPlay && PositionalMedia.lastPlay != scope

            if (keepAudio) scope.panorama && scope.panorama.setConstantRefresh(false)

            scope.arg.onPositionalMediaPause &&
                scope.arg.onPositionalMediaPause(e, {
                    keepAudio: keepAudio,
                    id: scope.arg.id,
                    currentTime: this.currentTime,
                    duration: this.duration,
                })
        }
        mediaObject.onseeked = function(e) {
            if (mediaObject) scope.drawImage(mediaObject)
            if (this.paused)
                //ensure that seeking to the first frame updates
                scope.panorama && scope.panorama.setNeedsRefresh()
        }
        mediaObject.ontimeupdate = function(e) {
            var percentComplete = this.currentTime / this.duration
            scope.arg.onPositionalMediaTimeUpdate &&
                scope.arg.onPositionalMediaTimeUpdate(e, { percentComplete: percentComplete, id: scope.arg.id })
        }
        mediaObject.onended = function(e) {
            scope.scene.removeEvent('draw', scope.drawVideo)
            scope.arg.onPositionalMediaEnded &&
                scope.arg.onPositionalMediaEnded(e, {
                    id: scope.arg.id,
                    autoplay: scope.arg.autoplay,
                })
        }
    }

    PositionalMedia.prototype.deviceIsMobile = function() {
        /**
         * Mobile Support Verification
         */
        if (typeof Browser == 'undefined') return false
        if (Browser.is('mobile') === false) return false
        return true
    }

    PositionalMedia.prototype.deviceSupportsLivingScenes = function(prompt) {
        /**
         * Mobile Support Verification
         */
        if (typeof Browser == 'undefined') return true
        if (Browser.is('mobile') === false) return true
        if (Browser.is('iphone') && Browser.getVersion() >= 11) return true
        if (Browser.is('android') && Browser.getVersion() >= 7) return true
        if (prompt) {
            var message = 'Action Zones are not support on this OS.',
                confirmMsg = typeof this.arg.onRequestAppInstall != 'undefined'
            if (confirmMsg) message += '\nDownload the App for an immersive Experience?'
            else message += '\nTap the VR button for an immersive Experience!'
            var installApp = confirmMsg ? confirm(message) : alert(message)
            if (installApp) {
                this.arg.onRequestAppInstall && this.arg.onRequestAppInstall()
            }
        }

        return false
    }

    PositionalMedia.prototype.getMediaObject = function() {
        try {
            return this.mesh.material.map.image.mediaObject
        } catch (e) {
            return false
        }
    }

    PositionalMedia.prototype.setMediaObject = function(mediaObject) {
        try {
            this.mesh.material.map.image.mediaObject = mediaObject
        } catch (e) {
            return false
        }
    }
    PositionalMedia.prototype.renderPhoto = function() {
        var self = this
        if (this.arg.media.photoURL) {
            //IMAGE
            var image = document.createElement('img')
            image.crossOrigin = 'anonymous'
            image.isPhoto = true
            image.isVideo = false
            image.hasVideo = this.arg.media.videoURL !== false
            image.onload = function() {
                var texture = self.mesh.material.map,
                    canvas = texture.image
                canvas.width = nearestPow2(image.width)
                canvas.height = nearestPow2(image.height)
                self.setMediaObject(image)
                requestAnimationFrame(function() {
                    self.drawImage(self.getMediaObject())
                    self.requestUpdate()
                    self.call('update', [this.arg])
                })
            }
            image.src = this.arg.media.photoURL
        } else {
            return false
        }
    }

    PositionalMedia.prototype.renderVideo = function(autoplay, promptDeviceSupport) {
        var self = this

        if (this.deviceSupportsLivingScenes(promptDeviceSupport) === false) {
            return
        }

        if (this.arg.media.videoURL) {
            //VIDEO
            var video = document.createElement('video')

            video.crossOrigin = 'anonymous'
            video.setAttribute('crossOrigin', 'anonymous')

            video.setAttribute('playsinline', '')
            video.src = this.arg.media.videoURL

            // This event listener is to ensure PM plays in IE-11.
            // See AV-405
            // https://youvisit.atlassian.net/browse/AV-405
            video.addEventListener('loadedmetadata', () => {
                video.isPhoto = false
                video.currentTime = this._lastPausedTime || 0
                video.hasVideo = video.isVideo = true

                this.bindVideoEvents(video)

                video.onloadeddata = function(e) {
                    video.play()
                }
                video.onerror = function(e) {
                    video.hasError = e
                }

                //When media is loaded and then played in builder,
                //the video is rerendered with a proper height/width
                //allows edges and resize handle to remain on screen
                var texture = this.mesh.material.map,
                    canvas = texture.image,
                    width = canvas.width,
                    height = canvas.height
                if (height && width) {
                    video.setAttribute('height', height.toString())
                    video.setAttribute('width', width.toString())
                }

                //These lines are intended to resolve the blue / black texture appearing in-lieu of the actual video texture
                this.mesh.material.needsUpdate = true
                texture.needsUpdate = true

                this.setMediaObject(video)
                if (autoplay) {
                    //attempt to play positional media
                    var playPromise = video.play()
                    // In browsers that don’t yet support this functionality,
                    // playPromise won’t be defined.
                    if (playPromise !== undefined) {
                        playPromise
                            .then(function() {
                                self.arg.onVideoPlay && self.arg.onVideoPlay(autoplay)
                            })
                            .catch(function(error) {
                                self.arg.onFailedToPlay && self.arg.onFailedToPlay(self)
                            })
                    } else {
                        self.arg.onVideoPlay && self.arg.onVideoPlay()
                    }
                }
            })
        } else {
            return false
        }
    }

    PositionalMedia.prototype.pause = function(fromAutoPlay) {
        var mediaObject = this.getMediaObject()
        if (mediaObject && mediaObject.isVideo && mediaObject.pause) {
            mediaObject.pause()
            var scope = this
            this._lastPausedTime = mediaObject.currentTime
            this.unloadVideoTimeout = setTimeout(function() {
                mediaObject.src = ''
                mediaObject.load()
                mediaObject = null
                scope.setMediaObject(null)
            }, 750)
        }
    }

    PositionalMedia.prototype.isPlaying = function(fromAutoPlay) {
        if (this.unloadVideoTimeout) {
            clearTimeout(this.unloadVideoTimeout)
        }
        var mediaObject = this.getMediaObject()
        if (mediaObject && mediaObject.isVideo && mediaObject.pause) {
            return !mediaObject.paused
        }
        return false
    }

    PositionalMedia.prototype.play = function(fromAutoPlay) {
        //ONLY PLAY IF (FOCUSED AND EDIT) OR IF IN PREVIEW
        var self = this
        var last = PositionalMedia.focused
        if (PositionalMedia.focused) {
            PositionalMedia.focused.setFocused(false)
        }
        self.setFocused(!self.viewMode)
        if (last === self || self.viewMode) {
            var mediaObject = this.getMediaObject()
            var willPlay = mediaObject ? mediaObject.paused || !mediaObject.isVideo : false
            //Ensure only 1 Positional Media plays at a time.
            if (willPlay) {
                if (PositionalMedia.lastPlay && PositionalMedia.lastPlay != self) {
                    PositionalMedia.lastPlay.pause() // support in progress PM
                }
                PositionalMedia.lastPlay = self
            }
            if (mediaObject && mediaObject.isVideo && mediaObject.play) {
                if (mediaObject.paused) {
                    self.call('play')

                    //attempt to play positional media
                    var playPromise = mediaObject.play()
                    // In browsers that don’t yet support this functionality,
                    // playPromise won’t be defined.
                    if (playPromise !== undefined) {
                        playPromise
                            .then(function() {
                                self.arg.onVideoPlay && self.arg.onVideoPlay()
                            })
                            .catch(function(error) {
                                self.arg.onFailedToPlay && self.arg.onFailedToPlay(self)
                            })
                    } else {
                        self.arg.onVideoPlay && self.arg.onVideoPlay()
                    }
                    self.showPause = true
                    clearTimeout(self.pauseTimeout)
                    self.pauseTimeout = setTimeout(function() {
                        self.showPause = false
                    }, 1500)
                } else {
                    mediaObject.pause()
                }
            } else {
                //first video play click
                this.renderVideo(true, !fromAutoPlay)
            }
        }
    }

    /**
     * Destroy
     */
    PositionalMedia.prototype.destroy = function() {
        $(this)
            .parent()
            .remove(this)
        $(this.title).remove()
        $(this.button).remove()

        this.stop(true)

        // Properly dispose of video object
        var mediaObject = this.getMediaObject()

        if (mediaObject && mediaObject.isVideo) {
            mediaObject.src = ''
            mediaObject.load()
        }

        this.scene.removeEvent('draw', this.drawVideo)
        panoramaUnBindMouseEvents(this.panorama)

        PositionalMedia.lastPlay = null

        this.material && this.material.dispose()
        this.geometry && this.geometry.dispose()

        if (this.mesh) {
            this.mesh.material.dispose()
            this.mesh.geometry.dispose()
        }

        this.panorama = null
    }

    PositionalMedia.prototype.isLive = function() {
        var po = this.arg
        return po.status === 'live' || po.status == 1
    }

    PositionalMedia.prototype.isFocused = function() {
        return PositionalMedia.focused === this
    }

    PositionalMedia.prototype.setFocused = function(focused) {
        if (focused) {
            if (PositionalMedia.focused) {
                PositionalMedia.focused.setFocused(false)
            }
            PositionalMedia.focused = this
        } else if (PositionalMedia.focused === this) {
            PositionalMedia.focused = null
        }
        this.points.forEach(function(point) {
            point.visible = focused
        })
        this.panorama.player.requestUpdate()
    }
    PositionalMedia.prototype.requestUpdate = function() {
        this.panorama.player.requestUpdate()
    }
    //Set the fade level for the positional media
    PositionalMedia.prototype.setFade = function(fade) {
        this.arg.fade = fade
        this.mesh.material.needsUpdate = true
        var texture = this.mesh.material.map,
            canvas = texture.image,
            mediaObject = canvas.mediaObject,
            that = this
        requestAnimationFrame(function() {
            that.drawImage(mediaObject)
            that.requestUpdate()
            that.call('update', [this.arg])
        })
    }
    //Set if the positional media will autoplay in the viewer
    PositionalMedia.prototype.setAutoplay = function(autoplay) {
        var needsUpdate = !!this.arg.autoplay != autoplay
        if (needsUpdate) {
            this.arg.autoplay = autoplay
            this.drawBorder()
            this.requestUpdate()
            this.call('update', [this.arg])
        }
    }
    PositionalMedia.prototype.isAutoplayEnabled = function() {
        return this.arg.autoplay
    }
    PositionalMedia.prototype.getDrawColor = function() {
        return this.isAutoplayEnabled() ? COLORS.AUTOPLAY : COLORS.DEFAULT
    }

    PositionalMedia.prototype.setViewMode = function(viewMode) {
        this.cylinders.forEach(function(cylinder) {
            cylinder.visible = !viewMode
        })
        this.singlePointEdges.forEach(function(edge) {
            edge.visible = !viewMode
        })
        if (this.arg.points.length === 1) {
            this.title.visible = !viewMode
        } else if (this.arg.points.length === 4) {
            this.title.style.display = viewMode ? 'none' : 'block'
        }
        this.setFocused(this.isFocused() && !viewMode)
        this.viewMode = viewMode
        this.panorama.player.requestUpdate()
    }

    PositionalMedia.prototype.drawImage = function(mediaObject) {
        if (mediaObject.hasError) return
        var texture = this.mesh.material.map,
            canvas = texture.image,
            context = canvas.getContext('2d'),
            width = canvas.width,
            height = canvas.height

        if (mediaObject && (mediaObject.complete || mediaObject.readyState === 4)) {
            if (this.isLive()) {
                // clear the visible canvas
                context.clearRect(0, 0, width, height)

                if (this.arg.fade && context) {
                    // draw the image
                    context.drawImage(mediaObject, 0, 0, width, height)
                    // change the gCO, source-in doesn't work in all browsers
                    context.globalCompositeOperation = 'destination-in'
                    // draw the clipping mask
                    var gW = width / 2,
                        gH = height / 2,
                        radialCenter = Math.min(gW, gH),
                        radialGradient = context.createRadialGradient(
                            radialCenter,
                            radialCenter, //Start X,Y
                            radialCenter / 1.5, //StartRadius
                            radialCenter,
                            radialCenter, //End X,Y
                            radialCenter //EndRadius
                        )

                    radialGradient.addColorStop(0, 'rgba(0,0,0,1)')
                    radialGradient.addColorStop(1, 'rgba(0,0,0,0)')
                    context.fillStyle = radialGradient
                    context.save()
                    var wS = gW / radialCenter,
                        hS = gH / radialCenter
                    context.scale(wS, hS)
                    context.fillRect(0, 0, width, height)
                    context.restore()
                    // always reset the default gCO
                    context.globalCompositeOperation = 'source-over'
                } else {
                    context.drawImage(mediaObject, 0, 0, width, height)
                }
            } else {
                var WIDTH_SCALE = width / CANVAS_WIDTH_DEFAULT
                var HEIGHT_SCALE = height / CANVAS_HEIGHT_DEFAULT
                var MAX_SCALE = Math.max(WIDTH_SCALE, HEIGHT_SCALE)
                //background
                context.fillStyle = COLORS.BACKGROUND
                context.fillRect(0, 0, width, height)
                //spinner
                context.beginPath()
                context.arc(width / 2, height / 2, MAX_SCALE * 30, Math.PI + this.theta, Math.PI * 2 + this.theta)
                context.strokeStyle = this.getDrawColor()

                context.lineWidth = 2 * MAX_SCALE
                context.stroke()
                //status
                context.font = Math.ceil(MAX_SCALE * 12) + 'px ProximaNova-Semibold'
                context.textAlign = 'center'
                context.textBaseline = 'middle'
                context.fillStyle = this.getDrawColor()
                context.fillText(this.arg.status.toUpperCase(), width / 2, (height / 4) * 3)
                //...
                var textWidth = context.measureText(this.arg.status.toUpperCase()).width / 2
                context.textAlign = 'left'
                context.fillText('...'.substr(0, Math.floor(this.dots)), width / 2 + textWidth, (height / 4) * 3)
            }
            texture.needsUpdate = true
            this.hasDrawnMedia = true
        }
    }

    function measureText(canvas, context, text, size, extra) {
        var font = (size * 2) / 3 + 'px ProximaNova-Semibold'
        context.font = font
        canvas.width = context.measureText(text).width + 100 + (extra || 0)
        context.font = font
    }

    PositionalMedia.prototype.stop = function(isDestroying) {
        var mediaObject = this.getMediaObject()
        var self = this
        if (mediaObject && mediaObject.isVideo && !mediaObject.paused) {
            mediaObject.pause()
            mediaObject.currentTime = 0
            if (!isDestroying) {
                setTimeout(function() {
                    self.drawImage(mediaObject)
                }, 200)
            }
        }
    }

    PositionalMedia.prototype.setPosition = function(vector) {
        if (this.arg.points.length === 1) {
            var mediaObject = this.getMediaObject(),
                length = vector.length(),
                scale = length / 10,
                width = mediaObject.width,
                height = mediaObject.height
            if (this.isLive()) {
                var resize = MAX_HEIGHT / Math.max(width, height)
                width *= resize
                height *= resize
            }

            this.mesh.position.copy(vector)
            this.mesh.lookAt(new THREE.Vector3(0, 0, 0))

            var title = this.title
            title && title.scale && title.scale.set(scale, scale, scale)
            var resize = this.points[0]
            resize && resize.scale && resize.scale.set(scale, scale, scale)
            //RESIZE
            var half_width = width / 2 / convert_units,
                half_height = height / 2 / convert_units
            resize && resize.position && resize.position.set(half_width, -half_height, 0)
            //TITLE
            var title_canvas = title && title.material && title.material.map.image
            title &&
                title.position &&
                title.position.set(
                    -half_width + (scale * title_canvas.width) / convert_units / 2,
                    half_height + (scale * button_size) / 2 / convert_units,
                    0
                )

            this._updateTitle()
            this._updateHandles()
            this._updateEdges({
                scale: scale,
                width: width,
                height: height,
            })
        } else if (this.arg.points.length === 4) {
            var geometry = (this.mesh.geometry = this.getGeometry())
            geometry.dynamic = true
            geometry.verticesNeedUpdate = true

            for (var i = 0; i < this.points.length; i++) {
                var p = this.arg.points[i]
                this.points[i].position.set(p.x, p.y, p.z)
            }

            this._updateEdges()
        }
    }
    //Redraw the edges
    PositionalMedia.prototype.drawBorder = function() {
        this._updateHandles()
        this._updateTitle()
        this._updateEdges()
    }
    PositionalMedia.prototype._updateHandles = function() {
        if (this.viewMode) {
            return
        }

        var points = this.arg.points,
            scope = this,
            handleColor = this.getDrawColor(),
            parent = points.length === 4 ? this : this.mesh
        if (points.length == 1) {
            //Adding the resize handle
            points.forEach(function(point, index) {
                if (scope.points[index]) {
                    //Update color
                    scope.points[index].material.color.set(handleColor)
                } else {
                    //Create drag handle
                    var dragHandle = scope.getDragHandle(0.3 * 0.8)
                    dragHandle.position.set(point.x, point.y, point.z)
                    dragHandle.addEvent('mousedown', function() {
                        if (!scope.viewMode) {
                            scope.setMoving('resize')
                            scope.setBorderVisible(false)
                        }
                    })

                    parent.add(dragHandle)
                    scope.points[index] = dragHandle
                }
                scope.points[index].visible = !scope.viewMode && !PositionalMedia.moving
            })
        } else {
            //Adding the drag handles
            points.forEach(function(point, index) {
                if (scope.points[index]) {
                    //Update color
                    scope.points[index].material.color.set(handleColor)
                } else {
                    //Create drag handle
                    var dragHandle = scope.getDragHandle(0.4)
                    dragHandle.position.set(point.x, point.y, point.z)
                    dragHandle.addEvent('mousedown', function() {
                        scope.setMoving('pin', point)
                        scope.setBorderVisible(false)
                    })

                    parent.add(dragHandle)
                    scope.points[index] = dragHandle
                }
                scope.points[index].visible = !scope.viewMode && !PositionalMedia.moving
            })
        }
    }
    PositionalMedia.prototype.setBorderVisible = function(visible) {
        if (this.isBorderVisible == visible) {
            this.isBorderVisible = visible
            return
        }

        //Show Edges?
        this.cylinders.forEach(function(cylinder) {
            cylinder.visible = visible
        })
        this.singlePointEdges.forEach(function(edge) {
            edge.visible = visible
        })
        //Show Handles?
        this.points.forEach(function(point) {
            point.visible = visible
        })

        //Show Title?
        if (this.points.length == 1 && this.title_mesh) {
            this.title_mesh.visible = visible
        } else {
            this.title.style.visibility = visible ? 'visible' : 'hidden'
        }

        //Trigger Update
        this.panorama.player.requestUpdate()
    }
    PositionalMedia.prototype._drawTitle = function(title, visible) {
        if (this.viewMode) {
            return
        }

        if (this.points.length == 1) {
            this.title_context.fillStyle = this.isAutoplayEnabled()
                ? COLORS.AUTOPLAY_TITLE_BACKGROUND
                : COLORS.DEFAULT_TITLE_BACKGROUND
            this.title_context.fillRect(0, 0, this.title_canvas.width, this.title_canvas.height)
            this.title_context.fillStyle = COLORS.DEFAULT_TITLE
            this.title_context.textAlign = 'center'
            this.title_context.textBaseline = 'middle'
            this.title_context.fillText(title, this.title_canvas.width / 2, this.title_canvas.height / 2)

            this.title_mesh.visible = visible
            this.title_texture.needsUpdate = true
        }
    }
    PositionalMedia.prototype._updateTitle = function() {
        if (this.viewMode) {
            return
        }

        var titleText = this.arg.title
        var visible = !this.viewMode && !PositionalMedia.moving
        if (this.points.length == 1) {
            if (this.title) {
                this._drawTitle(titleText, visible)
            } else {
                var title_canvas = document.createElement('canvas'),
                    title_context = title_canvas.getContext('2d'),
                    title_geometry = new THREE.PlaneGeometry(1 / convert_units, button_size / convert_units),
                    title_texture = new THREE.Texture(title_canvas),
                    title = (this.title = new THREE.Mesh(
                        title_geometry,
                        new THREE.MeshBasicMaterial({
                            map: title_texture,
                            side: THREE.DoubleSide,
                        })
                    ))

                title_texture.minFilter = THREE.LinearFilter
                this.mesh.add(title)
                title_canvas.height = button_size
                measureText(title_canvas, title_context, titleText, title_canvas.height)

                title_geometry.scale(title_canvas.width, 1, 1)

                this.title_canvas = title_canvas
                this.title_texture = title_texture
                this.title_context = title_context
                this.title_mesh = title

                this._drawTitle(titleText)
            }
        } else {
            if (this.title) {
                this.title.style.background = this.getDrawColor()
                this.title.style.visibility = visible ? 'visible' : 'hidden'
            } else {
                this.title = PositionalMedia.getElement(
                    this.panorama.renderer.domElement.parentNode,
                    titleText,
                    this.getDrawColor()
                )
            }
        }
    }
    PositionalMedia.prototype._updateEdges = function(props) {
        if (this.viewMode) {
            return
        }
        var points = this.arg.points,
            edgeColor = this.getDrawColor(),
            startPosition,
            endPosition,
            props = props || {},
            edge
        if (this.points.length == 1) {
            var parent = points.length === 4 ? this : this.mesh,
                edgeCount = 4,
                width = props.width || 0,
                height = props.height || 0,
                half_width = width / 2 / convert_units,
                half_height = height / 2 / convert_units,
                scale = props.scale || 0

            for (var ii = 0; ii < edgeCount; ii++) {
                if (this.singlePointEdges[ii] && Object.keys(props).length > 0) {
                    //Reposition edges
                    edge = this.singlePointEdges[ii]
                    switch (ii) {
                        case 0: //Top
                            edge.position.set(0, half_height, 0)
                            edge.scale.set(scale, width / convert_units, scale)
                            break
                        case 1: //Right
                            edge.position.set(-half_width, 0, 0)
                            edge.scale.set(scale, height / convert_units, scale)
                            break
                        case 2: //Bottom
                            edge.position.set(0, -half_height, 0)
                            edge.scale.set(scale, width / convert_units, scale)
                            break
                        case 3: //Left
                            edge.position.set(half_width, 0, 0)
                            edge.scale.set(scale, height / convert_units, scale)
                            break
                    }
                } else if (this.singlePointEdges[ii]) {
                    //Change edges color
                    this.singlePointEdges[ii].material.color.set(edgeColor)
                } else {
                    //Create the edges
                    edge = getCylinder({
                        vstart: new THREE.Vector3(0, 0, 0),
                        vend: new THREE.Vector3(0, 1, 0),
                        scene: parent,
                        color: edgeColor,
                    })
                    switch (ii) {
                        case 0: //Top
                        case 2: //Bottom
                            edge.rotation.set(0, 0, Math.PI / 2)
                            break
                    }
                    this.singlePointEdges[ii] = edge
                }
                this.singlePointEdges[ii].visible = !this.viewMode && !PositionalMedia.moving
            }
        } else {
            for (var ii = 0; ii < this.points.length; ii++) {
                this.remove(this.cylinders[ii])
                startPosition = this.points[ii].position
                endPosition = this.points[(ii + 1) % this.points.length].position
                this.cylinders[ii] = getCylinder({
                    vstart: startPosition,
                    vend: endPosition,
                    scene: this,
                    color: this.getDrawColor(),
                })
                this.cylinders[ii].visible = !this.viewMode && !PositionalMedia.moving
            }
        }
    }
    PositionalMedia.prototype.getDragHandle = function(radius) {
        var sphere = new THREE.SphereGeometry(radius, 36, 36)
        var material = new THREE.MeshBasicMaterial({
            color: this.getDrawColor(),
            side: THREE.DoubleSide,
            transparent: true,
            opacity: 0.5,
        })
        return new THREE.Mesh(sphere, material)
    }

    PositionalMedia.prototype.getPosition = function() {
        var mediaObject = this.getMediaObject()
        var xy

        if (mediaObject.isVideo || mediaObject.hasVideo) {
            var total = this.arg.points.reduce(
                function(total, point) {
                    return {
                        x: point.x + total.x,
                        y: point.y + total.y,
                        z: point.z + total.z,
                    }
                },
                { x: 0, y: 0, z: 0 }
            )
            total.x /= this.arg.points.length
            total.y /= this.arg.points.length
            total.z /= this.arg.points.length

            var container = $(this.panorama.renderer.domElement)
            var width = container.width()
            var height = container.height()
            xy = createVector(total.x, total.y, total.z, this.panorama.camera.getCamera(), width, height)
        }

        return xy
    }

    PositionalMedia.prototype.moveTitle = function() {
        var container = $(this.panorama.renderer.domElement)
        var width = container.width()
        var height = container.height()

        if (this.arg.points.length === 4) {
            var position = this.points[0].position
            var xy = createVector(position.x, position.y, position.z, this.panorama.camera.getCamera(), width, height)
            this.title.style.display = xy.z < 1 && !this.viewMode && PositionalMedia.focused === this ? 'block' : 'none'
            this.title.style.left = Math.round(xy.x - 10) + 'px'
            this.title.style.top = Math.round(xy.y - 10) + 'px'
        }
    }

    PositionalMedia.prototype.moveButton = function(xy) {
        if (this.arg.showUI) {
            var mediaObject = this.getMediaObject()

            var button = this.button
            if (button) {
                button.css({
                    position: 'absolute',
                    left: xy.x,
                    top: xy.y,
                    transform: 'translate(-50%, -50%)',
                    zIndex: 5,
                    borderRadius: '50%',
                    height: '26px',
                    background: 'rgba(0, 0, 0, 0.6)',
                })
                button.eq(0)[this.arg.status === 'live' ? 'show' : 'hide']()
                if (mediaObject.isVideo) {
                    button
                        .find('.play')
                        .eq(0)
                        [xy.z < 1 && mediaObject.paused ? 'show' : 'hide']()
                    button
                        .find('.pause')
                        .eq(0)
                        [xy.z < 1 && !mediaObject.paused && this.showPause ? 'show' : 'hide']()
                } else {
                    button
                        .find('.play')
                        .eq(0)
                        [xy.z < 1 ? 'show' : 'hide']()
                    button
                        .find('.pause')
                        .eq(0)
                        ['hide']()
                }
            }
        }
    }

    function nearestPow2(aSize) {
        return aSize //return Math.pow( 2, Math.ceil( Math.log( aSize ) / Math.log( 2 ) ) );
    }

    function videoTexture(geometry, mediaInfo, callback) {
        var self = this
        //CANVAS
        var canvas = document.createElement('canvas')
        canvas.width = CANVAS_WIDTH_DEFAULT
        canvas.height = CANVAS_HEIGHT_DEFAULT
        if (mediaInfo.photoURL) {
            //IMAGE
            var image = document.createElement('img')
            image.crossOrigin = 'anonymous'
            image.isPhoto = true
            image.isVideo = false
            image.hasVideo = mediaInfo.videoURL !== false
            image.onload = function() {
                callback && callback(image, image.width, image.height)
            }
            image.src = mediaInfo.photoURL

            canvas.mediaObject = image
        } else {
            console.log('MediaInfo missing required photoURL.')
            return false
        }
        var texture = new THREE.Texture(canvas)
        texture.minFilter = THREE.LinearFilter
        texture.magFilter = THREE.LinearFilter
        texture.generateMipmaps = true
        return new THREE.Mesh(
            geometry,
            new THREE.MeshBasicMaterial({
                map: texture,
                side: THREE.DoubleSide,
                transparent: true,
            })
        )
    }
    function getCylinder(props) {
        var vstart = props.vstart,
            vend = props.vend,
            scene = props.scene,
            color = props.color

        var HALF_PI = Math.PI * 0.5
        var distance = vstart.distanceTo(vend)
        var position = vend
            .clone()
            .add(vstart)
            .divideScalar(2)

        var material = new THREE.MeshBasicMaterial({
            color: color,
            side: THREE.DoubleSide,
            transparent: true,
        })
        var cylinder = new THREE.CylinderGeometry(0.05, 0.05, distance, 10, 10, false)
        var mesh = new THREE.Mesh(cylinder, material)
        mesh.renderOrder = 1
        scene.add(mesh)
        var orientation = new THREE.Matrix4() //a new orientation matrix to offset pivot
        var offsetRotation = new THREE.Matrix4() //a matrix to fix pivot rotation

        orientation.lookAt(vstart, vend, new THREE.Vector3(0, 1, 0)) //look at destination
        offsetRotation.makeRotationX(HALF_PI) //rotate 90 degs on X
        orientation.multiply(offsetRotation) //combine orientation with rotation transformations
        cylinder.applyMatrix(orientation)
        mesh.position.copy(position)
        return mesh
    }

    function createVector(x, y, z, camera, width, height) {
        var p = new THREE.Vector3(x, y, z)
        var vector = p.project(camera)
        vector.x = ((vector.x + 1) / 2) * width
        vector.y = (-(vector.y - 1) / 2) * height
        return vector
    }

    PositionalMedia.prototype.getGeometry = function() {
        if (this.arg.points.length === 1) {
            return new THREE.PlaneGeometry(1 / convert_units, 1 / convert_units)
        } else if (this.arg.points.length === 4) {
            var geometry = new THREE.Geometry(),
                totalX = 0,
                totalY = 0,
                totalZ = 0,
                pointCount = this.arg.points.length
            geometry.vertices = this.arg.points.map(function(point) {
                totalX += point.x
                totalY += point.y
                totalZ += point.z
                return new THREE.Vector3(point.x, point.y, point.z)
            })
            geometry.vertices.push(new THREE.Vector3(totalX / pointCount, totalY / pointCount, totalZ / pointCount))
            //Add each face to the geometry
            for (var ii = 0; ii < pointCount; ++ii) {
                //Connect the points
                //ex: [ {0,1,center}, {1,2,center}, ... ]
                geometry.faces.push(new THREE.Face3(ii, (ii + 1) % pointCount, pointCount))
            }

            var midPoint = new THREE.Vector2(0.5, 0.5)
            //Clockwise map the faces
            geometry.faceVertexUvs[0][0] = [new THREE.Vector2(0, 1), new THREE.Vector2(1, 1), midPoint]
            geometry.faceVertexUvs[0][1] = [new THREE.Vector2(1, 1), new THREE.Vector2(1, 0), midPoint]
            geometry.faceVertexUvs[0][2] = [new THREE.Vector2(1, 0), new THREE.Vector2(0, 0), midPoint]
            geometry.faceVertexUvs[0][3] = [new THREE.Vector2(0, 0), new THREE.Vector2(0, 1), midPoint]
            return geometry
        }
    }

    PositionalMedia.getElement = function(parent, title, color) {
        var div = document.createElement('div')
        div.innerHTML = title
        div.style.background = color
        div.style.borderRadius = '5px'
        div.style.padding = '6.5px 13px 6.5px 10px'
        div.style.color = COLORS.WHITE
        div.style.fontfamily = 'ProximaNova'
        div.style.fontSize = '8.4px'
        div.style.fontWeight = 600
        div.style.position = 'absolute'
        div.style.zIndex = 5
        div.style.transform = 'translate(-100%, -100%)'
        div.className = 'positional_media pm_title'
        parent.appendChild(div)
        return div
    }

    return PositionalMedia
})()

export default PositionalMedia
